import React from 'react';

export default function LazyLoader() {
  return (
 
     <div class="lds-facebook"><div></div><div></div><div>
      </div>
    </div>
  );
}